export default {
  progress: {},
}
